<div class="flex justify-content-start align-items-center mb-3 gap-3 pb-3">
   <div class="bg-white p-3 border-1 border-blue-100 border-round-lg">
      <i class="pi pi-chart-pie text-blue-500 text-lg"></i>
   </div>
   <div class="text-2xl text-700 font-semibold flex flex-column gap-1">
      Reporte {{ 'DATA.MODULES.REPORTS.BC.' + this.report()?.title | translate }}
      <div class="text-sm font-normal text-600">
         {{ report()?.description! | translate }}
      </div>
   </div>
</div>

<div class="bg-white border-1 border-blue-100 border-round-lg p-4 gap-3 shadow-1">
   <form
      *ngIf="filtersForm && fields() as fieldsArr"
      [formGroup]="filtersForm"
      class="p-fluid grid align-content-center"
   >
      <ng-container *ngFor="let field of fieldsArr">
         <div class="col-12 md:col-4 lg:col-3">
            <label class="font-semibold text-600 mb-2 block">
               {{ 'DATA.MODULES.REPORTS.LABEL.' + (field.label ? field.label : field.name) | translate }}
               <span *ngIf="field.required && field.name !== 'collectorId' && field.name !== ''" class="text-red-500"
                  >*</span
               >
               <i
                  *ngIf="field.name !== '' && field.name !== 'collectorId' && field.required && !field.hideTooltip"
                  class="pi pi-question-circle ml-2 text-500"
                  [pTooltip]="
                     field.tooltip
                        ? (field.tooltip | translate)
                        : ('DATA.MODULES.REPORTS.TOOLTIP.' + field.name | translate)
                  "
               ></i>
            </label>

            <ng-container [ngSwitch]="field.type">
               <input
                  *ngSwitchCase="'text'"
                  pInputText
                  [formControlName]="field.name"
                  placeholder="{{ 'DATA.MODULES.REPORTS.LABEL.' + field.name | translate }}"
                  class="w-full"
               />

               <ng-container *ngSwitchCase="'dropdown'">
                  <app-tree-select
                     *ngIf="field.name === 'campaignId'; else normalDropdown"
                     class="w-full"
                     [selectionMode]="SelectionMode.SINGLE"
                     placeholder="{{ 'DATA.MODULES.REPORTS.LABEL.' + field.name | translate }}"
                     [nodes]="campaignNodes"
                     [enableReset]="!field.required"
                     [enableSearch]="true"
                     [selectedKeys]="
                        field.required && campaignNodes.length
                           ? getFirstLeafKey(campaignNodes)
                              ? [getFirstLeafKey(campaignNodes)!]
                              : []
                           : []
                     "
                     (selectionChange)="onTreeSelectChange($event, field.name)"
                  ></app-tree-select>

                  <ng-template #normalDropdown>
                     <p-dropdown
                        *ngIf="field.name !== 'debtAgingRanges'; else multiSelect"
                        [formControlName]="field.name"
                        [options]="fieldsOptions()[field.name] || []"
                        placeholder="{{ 'DATA.MODULES.REPORTS.LABEL.' + field.name | translate }}"
                        class="w-full"
                        [showClear]="!field.required || haveSameCurrency(this.collectors)"
                     ></p-dropdown>

                     <ng-template #multiSelect>
                        <p-multiSelect
                           [formControlName]="field.name"
                           [options]="fieldsOptions()[field.name] || []"
                           placeholder="{{ 'DATA.MODULES.REPORTS.LABEL.' + field.name | translate }}"
                           class="w-full"
                           display="chip"
                        ></p-multiSelect>
                     </ng-template>
                  </ng-template>
               </ng-container>

               <p-calendar
                  *ngSwitchCase="'date'"
                  [formControlName]="field.name"
                  [showIcon]="true"
                  [view]="field.dateView || 'date'"
                  [dateFormat]="field.dateView === 'month' ? 'mm/yy' : 'dd/mm/yy'"
                  [readonlyInput]="true"
                  [iconDisplay]="'input'"
                  class="w-full"
               >
               </p-calendar>

               <p-calendar
                  *ngSwitchCase="'dateRange'"
                  [formControlName]="field.name"
                  selectionMode="range"
                  [showIcon]="true"
                  [readonlyInput]="true"
                  dateFormat="dd/mm/yy"
                  [iconDisplay]="'input'"
                  class="w-full"
               ></p-calendar>
            </ng-container>
         </div>
      </ng-container>

      <div class="flex align-self-end mb-3">
         <p-button
            [rounded]="true"
            severity="secondary"
            (onClick)="resetFilters()"
            icon="pi pi-undo"
            [text]="true"
            [pTooltip]="'DATA.COMMON.GENERIC.RESET_FILTERS' | translate"
         />
      </div>
   </form>

   <div *ngIf="report()!.type == ReportType.CAMPAIGNS_BY_MONTH" class="flex -pt-2 pb-2 w-full justify-content-end">
      <p-chip icon="pi pi-info-circle" [label]="'DATA.MODULES.REPORTS.INFO.CAMPAIGNS' | translate"></p-chip>
   </div>

   <div *ngIf="report()!.type == ReportType.COLLECTORS" class="flex -pt-2 pb-2 w-full justify-content-end">
      <p-chip icon="pi pi-info-circle" [label]="'DATA.MODULES.REPORTS.INFO.COLLECTORS' | translate"></p-chip>
   </div>

   <ng-container *ngIf="safeUrl" class="pt-8">
      <iframe
         [src]="safeUrl"
         width="100%"
         height="800"
         frameborder="0"
         style="overflow: hidden; border: none"
         allowtransparency
      >
      </iframe>

      <div *ngIf="noDataFilters()" class="text-center mt-8">
         <h2>Filtros erróneos</h2>
         <p>Se deben rellenar los filtros adecuadamente para realizar la búsqueda</p>
      </div>
   </ng-container>
</div>
